import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { FiChevronDown, FiArrowRight } from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', value: 1, color: '#E5E7EB' }];

export const AttendanceSummary = ({ data, isLoading = false }) => {
  const hasData = Boolean(data);
  const { overall, segments } = data || { overall: 0, segments: EMPTY_SEGMENT };

  return (
    <div
      className={styles.attendanceCard}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Attendance Summary</span>
        <button className={styles.dayDropdown}>
          Today <FiChevronDown size={12} />
        </button>
      </div>

      <div className={styles.attendanceContent}>
        <div className={styles.attendanceChartArea}>
          <ResponsiveContainer width={140} height={140}>
            <PieChart>
              <Pie
                data={segments}
                cx="50%"
                cy="50%"
                innerRadius={46}
                outerRadius={68}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
                strokeWidth={0}
              >
                {segments.map((seg) => (
                  <Cell key={seg.name} fill={seg.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.attendanceCenter}>
            <div className={styles.attendanceCenterValue}>{overall}%</div>
            <div className={styles.attendanceCenterLabel}>Overall</div>
            <div className={styles.attendanceCenterLabel}>Attendance</div>
          </div>
        </div>

        {hasData && (
          <div className={styles.attendanceLegend}>
            {segments.map((seg) => (
              <div key={seg.name} className={styles.attendanceLegendItem}>
                <div className={styles.attendanceLegendLeft}>
                  <div
                    className={styles.attendanceLegendDot}
                    style={{ backgroundColor: seg.color }}
                  />
                  {seg.name}
                </div>
                <span className={styles.attendanceLegendValue}>
                  {seg.value}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      <button className={styles.viewLink}>
        View attendance report <FiArrowRight size={13} />
      </button>
    </div>
  );
};
